import dataProvider from '../providers/dataProvider';

export const getGeneral = async () => {
  const result = await dataProvider.getGeneral();
  return result.data;
};
export const getLandingGeneral = async (type: string) => {
  const result = await dataProvider.getLandingGeneral(type);
  return result.data;
};
